// import { useState } from 'react';
// import { usePostOperations } from '../hooks/usePostOperations';
// import { isValidPost } from '../utils/postUtils';
// import { useGetPostCommentsQuery, useCommentOnPostMutation } from '../store/api/postApi';
// import PostHeader from './PostHeader';
// import PostContent from './PostContent';
// import PostActions from './PostActions';
// import CommentSection from './CommentSection';
// import styles from './Post.module.css';
// import { useGetProfileQuery } from '../store/api/profileApi';
// import ShareModal from './ShareModal';
// import PostLikesModal from './PostLikesModal';
// import { FaThumbsUp } from 'react-icons/fa';

// export default function Post({ post, isOwner, openComments = false  }) {
//   const [showMenu, setShowMenu] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editedContent, setEditedContent] = useState(post?.caption || '');
//   const [editedVisibility, setEditedVisibility] = useState(post?.visibility ?? 0);
//   const [isDeleted, setIsDeleted] = useState(false);
//   const [showComments, setShowComments] = useState(openComments);
//   const [showLikes, setShowLikes] = useState(false);
//   const [showShareModal, setShowShareModal] = useState(false);

//     const { data: profileData } = useGetProfileQuery();

//   const {
//     handleToggleLike,
//     handleShare,
//     handleUpdate,
//     handleDelete,
//     handleSave,
//     isLiking,
//     isSharing,
//     isUpdating,
//     isDeleting,
//     isSaving,
//   } = usePostOperations(post.id, post.type, {
//     onSuccess: (action) => {
//       if (action === 'update') {
//         setIsEditing(false);
//         setShowMenu(false);
//       }
//       if (action === 'delete') {
//         setIsDeleted(true);
//       }
//     },
//   });

//   // Only fetch comments when the section is open
//   const { data: comments = [], isLoading: isLoadingComments } = useGetPostCommentsQuery({ postId: post.id, type: post.type }, {
//     skip: !showComments,
//   });

//   const [commentOnPost, { isLoading: isCommenting }] = useCommentOnPostMutation();

//   const handleComment = async (text, parentCommentId = null) => {
//     const result = await commentOnPost({
//       postId: post.id,
//       commentText: text,
//       parentCommentId,
//       type: post.type,
//     }).unwrap();
//     return result;
//   };

//   if (isDeleted || !isValidPost(post)) return null;

//   return (
//     <div className={styles.postContainer}>
//       <PostHeader
//         post={post}
//         isOwner={isOwner}
//         showMenu={showMenu}
//         onToggleMenu={() => setShowMenu((p) => !p)}
//         onEdit={() => {
//           setIsEditing(true);
//           setShowMenu(false);
//         }}
//         onDelete={handleDelete}
//         onSave={() => handleSave(post.isSaved)}
//         onReport={() => alert('Report coming soon')}
//         isDeleting={isDeleting}
//         isUpdating={isUpdating}
//         isSaving={isSaving}
//       />

// <PostContent
//   post={post}
//   isEditing={isEditing}
//   editedContent={editedContent}
//   editedVisibility={editedVisibility}
//   setEditedVisibility={setEditedVisibility}
//   onContentChange={setEditedContent}
//   onSave={() => handleUpdate(editedContent, editedVisibility)}
//   onCancel={() => {
//     setEditedContent(post.caption || '');
//     setEditedVisibility(post.visibility ?? 0);
//     setIsEditing(false);
//   }}
//   isUpdating={isUpdating}
// />

//       {!isEditing && (
//         <>
//           {post.likesCount > 0 && (
//             <div
//               className={styles.likesSummary}
//               onClick={() => setShowLikes(true)}
//             >
//               <span className={styles.likeIcon}><FaThumbsUp /></span>
//               <span className={styles.likesText}>
//                 {post.likesCount} {post.likesCount === 1 ? "like" : "likes"}
//               </span>
//             </div>
//           )}

//           <PostActions
//             post={post}
//             onLike={() => handleToggleLike(post.isLikedByMe)}
//             onComment={() => setShowComments((prev) => !prev)}
//             onShare={() => setShowShareModal(true)}
//             isLiking={isLiking}
//             isSharing={isSharing}
//             showCommentSection={showComments}
//           />
//         </>
//       )}

//       {/* Inline comments — LinkedIn style */}
//       {showComments && (
//         <div className={styles.commentWrapper}>
//           {isLoadingComments ? (
//             <p className={styles.loadingComments}>Loading comments…</p>
//           ) : (
//             <CommentSection
//               postId={post.id}
//               comments={comments}
//               commentsCount={comments.length}
//               onSubmitComment={handleComment}
//               isCommenting={isCommenting}
//               currentUser={profileData} // Pass current user info for comment attribution
//               postOwnerId={post?.user?.id}
//             />
//           )}
//         </div>
//       )}

// <ShareModal
//   isOpen={showShareModal}
//   onClose={() => setShowShareModal(false)}
//   post={post}
// />

// <PostLikesModal
//   postId={post.id}
//   postType={post.type}
//   open={showLikes}
//   onClose={() => setShowLikes(false)}
// />
//     </div>
//   );
// }

import { useState } from "react";
import { usePostOperations } from "../hooks/usePostOperations";
import { isValidPost } from "../utils/postUtils";
import {
  useGetPostCommentsQuery,
  useCommentOnPostMutation,
} from "../store/api/postApi";
import PostHeader from "./PostHeader";
import PostContent from "./PostContent";
import PostActions from "./PostActions";
import CommentSection from "./CommentSection";
import styles from "./Post.module.css";
import { useGetProfileQuery } from "../store/api/profileApi";
import ShareModal from "./ShareModal";
import ReportModal from "./ReportModal";
import PostLikesModal from "./PostLikesModal";
import { FaThumbsUp } from "react-icons/fa";

export default function Post({
  post,
  isOwner,
  openComments = false,
  disableNavigation = false,
}) {
  const [showMenu, setShowMenu] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(post?.caption || "");
  const [editedVisibility, setEditedVisibility] = useState(
    post?.visibility ?? 0,
  );
  const [isDeleted, setIsDeleted] = useState(false);
  const [showComments, setShowComments] = useState(openComments);
  const [showLikes, setShowLikes] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);

  const { data: profileData } = useGetProfileQuery();

  const {
    handleToggleLike,
    handleShare,
    handleUpdate,
    handleDelete,
    handleSave,
    isLiking,
    isSharing,
    isUpdating,
    isDeleting,
    isSaving,
  } = usePostOperations(post.id, post.type, {
    onSuccess: (action) => {
      if (action === "update") {
        setIsEditing(false);
        setShowMenu(false);
      }
      if (action === "delete") {
        setIsDeleted(true);
      }
    },
  });

  // Only fetch comments when the section is open
  const { data: comments = [], isLoading: isLoadingComments } =
    useGetPostCommentsQuery(
      { postId: post.id, type: post.type },
      {
        skip: !showComments,
      },
    );

  const [commentOnPost, { isLoading: isCommenting }] =
    useCommentOnPostMutation();

  const handleComment = async (text, parentCommentId = null) => {
    const result = await commentOnPost({
      postId: post.id,
      commentText: text,
      parentCommentId,
      type: post.type,
    }).unwrap();
    return result;
  };

  if (isDeleted || !isValidPost(post)) return null;

  return (
    <div className={styles.postContainer}>
      <PostHeader
        post={post}
        isOwner={isOwner}
        showMenu={showMenu}
        onToggleMenu={() => setShowMenu((p) => !p)}
        onEdit={() => {
          setIsEditing(true);
          setShowMenu(false);
        }}
        onDelete={handleDelete}
        onSave={() => handleSave(post.isSaved)}
        onReport={() => setShowReportModal(true)}
        isDeleting={isDeleting}
        isUpdating={isUpdating}
        isSaving={isSaving}
      />

      <PostContent
        post={post}
        isEditing={isEditing}
        editedContent={editedContent}
        editedVisibility={editedVisibility}
        setEditedVisibility={setEditedVisibility}
        onContentChange={setEditedContent}
        onSave={() => handleUpdate(editedContent, editedVisibility)}
        onCancel={() => {
          setEditedContent(post.caption || "");
          setEditedVisibility(post.visibility ?? 0);
          setIsEditing(false);
        }}
        isUpdating={isUpdating}
        disableNavigation={disableNavigation}
      />

      {!isEditing && (
        <>
          {post.likesCount > 0 && (
            <div
              className={styles.likesSummary}
              onClick={() => setShowLikes(true)}
            >
              <span className={styles.likeIcon}>
                <FaThumbsUp />
              </span>
              <span className={styles.likesText}>
                {post.likesCount} {post.likesCount === 1 ? "like" : "likes"}
              </span>
            </div>
          )}

          <PostActions
            post={post}
            onLike={() => handleToggleLike(post.isLikedByMe)}
            onComment={() => setShowComments((prev) => !prev)}
            onShare={() => setShowShareModal(true)}
            isLiking={isLiking}
            isSharing={isSharing}
            showCommentSection={showComments}
          />
        </>
      )}

      {/* Inline comments — LinkedIn style */}
      {showComments && (
        <div className={styles.commentWrapper}>
          {isLoadingComments ? (
            <p className={styles.loadingComments}>Loading comments…</p>
          ) : (
            <CommentSection
              postId={post.id}
              comments={comments}
              commentsCount={comments.length}
              onSubmitComment={handleComment}
              isCommenting={isCommenting}
              currentUser={profileData} // Pass current user info for comment attribution
              postOwnerId={post?.user?.id}
            />
          )}
        </div>
      )}

      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        post={post}
      />

      <PostLikesModal
        postId={post.id}
        postType={post.type}
        open={showLikes}
        onClose={() => setShowLikes(false)}
      />

      {showReportModal && (
        <ReportModal
          postId={post.id}
          postType={post.type}
          onClose={() => setShowReportModal(false)}
        />
      )}
    </div>
  );
}
